import type {
  GetTestResultCountQuery,
  Test_Result_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTestResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type TestResultCountArgs = {
  // Resolved entity-filter selection — drives the tRPC path. Empty/absent ⇒
  // no entity filter.
  entityIds?: string[];
  // The equivalent Hasura bool_exp (incl. the RatingType predicate) — drives
  // the GraphQL fallback so the flag-gated twin counts identically. Built by
  // useEntityWhereFilter.
  where?: Test_Result_Bool_Exp;
};

export const useGetTestResultCount = createQueryHook<
  TestResultCountArgs,
  number,
  GetTestResultCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.testResult.testResultCount.queryOptions({
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    test_result_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetTestResultCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
